import { SET_THEME } from '../actions/themeActions';

const initialState = {
  mode: 'day'
};

const theme = (state = initialState, action) => {
  switch (action.type) {
    case SET_THEME:
      return {
        mode: action.mode === 'night' ? 'night' : 'day'
      };
    default:
      return state;
  }
};

export default theme;
